function Skills() {
  return (
    <section className="mb-5">
      <h3>Skills</h3>
      <ul>
        <li>HTML, CSS, JavaScript (ES6)</li>
        <li>React.js</li>
        <li>Bootstrap</li>
        <li>Responsive Web Development</li>
        <li>API Integration</li>
      </ul>
    </section>
  );
}

export default Skills;
